import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../use.store';
import { getLocationPoi } from '../utils/functions';

const UnitNumber = observer(({ poi, shape }) => {
    const { mapStore } = useStores();

    return (
        <div>
            {shape?.name || getLocationPoi(mapStore, poi).length > 60 ? (
                <div className="running-text-seven">
                    <span
                        className="text-[#FF6200] text-[8px] sm:text-[10px] md:text-[12px] font-regular"
                        style={{
                            animationDuration: `${poi.name.length * 0.25}s`,
                        }}
                    >
                        {shape ? shape.name : getLocationPoi(mapStore, poi)}
                    </span>
                </div>
            ) : (
                <p className="text-[#FF6200] text-[8px] sm:text-[10px] font-regular">
                    {shape ? shape.name : getLocationPoi(mapStore, poi)}
                </p>
            )}
        </div>
    );
});

export default UnitNumber;
